<template>
  <div id="OpenApiProductList" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">O</span>pen API {{ pageData.open_id }}</div>
        <div class="col-3 t-r f22 pr3" @click="select_all_on()">
          <i class="iconfont icon-checkbox-xuanzhong f22 color-primary" v-if="select_all"></i>
          <i class="iconfont icon-checkbox-weixuan f22 color-muted" v-else></i>
        </div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 bb1" v-for="(product,product_i) in data_list" v-bind:key="product_i">
        <div class="col-12">
          <div class="col-12 bg-color-white p5">
              <div class="col-10 pl10 pt8">
                <div class="col-12 f14">{{ product.product_code }}</div>
                <div class="col-12 f14">{{ product.product_name }}</div>
              </div>
              <div class="col-2 color-muted t-r lh50 pr5" @click="select_on(product_i)">
                <i class="iconfont icon-checkbox-xuanzhong f22 color-primary" v-if="product.status == 1"></i>
                <i class="iconfont icon-checkbox-weixuan f22 color-muted" v-else></i>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 t-c pt10 pb10">
      <page-component :page-config="pageConfigTotal" @changeCurrentPage="changePage"></page-component>
    </div>
  </div>
</template>
<script>
import pageComponent from "../pageComponent"
export default {
  name: 'OpenApiProductList',
  data () {
    return {
      pageData: {
        open_id: this.$route.query.open_id
      },
      data_list: [],
      pageConfigTotal:{total:0,pageSize:50,pageNo:1},
      select_all: false
    }
  },
  created: function () {
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var post_data = {};
      post_data.open_id = this.pageData.open_id;
      post_data.page = this.$store.state.app_args.product_page - 1;
      this.post(this.api_url + 'manage/open_api_product_list', post_data).then((res)=>{
        if(res.status == 1){
          console.log(res.data);
          this.data_list = res.data.product_list;
          this.product_count = res.data.product_count;
          this.pageConfigTotal.total = res.data.product_count;
          this.pageConfigTotal.pageNo = this.$store.state.app_args.product_page;
        }else{
          this.data_list = []
        }
      })
    },
    changePage(page){
      this.pageConfigTotal.pageNo = page
      this.$store.commit('setAppArgs',{product_page: page});
      this.get_list_data();
      this.select_all = false;
    },
    select_all_on(){
      this.select_all = !this.select_all;
      this.update_select_on();
    },
    select_on(product_i){
      console.log(this.data_list[product_i].status);
      this.data_list[product_i].status = !this.data_list[product_i].status;
    },
    update_select_on(){
      let update_list = [];
      for(var i = 0; i < this.data_list.length; i++){
        if(this.data_list[i].status != this.select_all){
          this.data_list[i].status = this.select_all ? 1 : 0;
          update_list.push(this.data_list[i]);
        }
      }
      if(update_list.length == 0){
        return;
      }
      console.log(update_list);
      let post_data = {};
      post_data.open_id = this.pageData.open_id;
      post_data.product_list = update_list;
      this.post(this.api_url + 'manage/open_api_product_select', post_data).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
        }
      })
    }
  },
  components:{'page-component':pageComponent}
}
</script>



// WEBPACK FOOTER //
// src/components/Main/OpenApiProductList.vue